import { render } from "./highlighted-text.vue?vue&type=template&id=150c76d2&scoped=true&ts=true"
import script from "./highlighted-text.vue?vue&type=script&lang=ts"
export * from "./highlighted-text.vue?vue&type=script&lang=ts"

import "./highlighted-text.vue?vue&type=style&index=0&id=150c76d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150c76d2"]])

export default __exports__